<template>
    <countdown :left-time="tempo * 1000" @finish="endCallBack()" ref="countdown">
        <template slot="process" slot-scope="data">
            <div class="text-center">
                <span>
                    <small>{{ titulo }}</small>
                </span>
                <br />
                <strong>
                    <span>{{ data.timeObj.h }}</span>
                    <i>:</i>
                    <span>{{ data.timeObj.m }}</span>
                    <i>:</i>
                    <span>{{ data.timeObj.s }}</span>
                </strong>
            </div>
        </template>
        <template slot="finish">
			<span>
				Atualizando...
			</span>
		</template>
    </countdown>
</template>

<script>
export default {
    name: 'TempoRegressivo',

    props: {
        tempo: {
            type: Number,
            default: () => 30
        },

        titulo: {
            type: String,
            default: () => 'Tempo Restante'
        }
    },

    data() {
        return {
        }
    },

    methods: {
        endCallBack() {
			this.$emit('timeout')
			this.$refs.countdown.startCountdown(true)
        }
    },

    created() {}
}
</script>



// WEBPACK FOOTER //
// src/components/TempoRegressivo.vue